/* eslint-disable quotes, quote-props, comma-dangle */

// mock reponses for the google payments API

const getPurchasesAfterBuyResponse = {
	"response": {
		"details": [
			// {
			// 	"kind": "chromewebstore#payment",
			// 	"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
			// 	"sku": "dog_classicdoggo",
			// 	"createdTime": "1387221267247",
			// 	"state": "PAYMENT_REJECTED",
			// },
			// {
			// 	"kind": "chromewebstore#payment",
			// 	"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
			// 	"sku": "dog_classicdoggo",
			// 	"createdTime": "1387221267249",
			// 	"state": "ACTIVE"
			// },
			// {
			// 	"kind": "chromewebstore#payment",
			// 	"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
			// 	"sku": "dog_classicdoggo",
			// 	"createdTime": "1387221267248",
			// 	"state": "PAYMENT_REJECTED",
			// },
		],
	},
};

export const getPurchasesResponse = {
	"response": {
		"details": [
			{
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "dog_lildoggo",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			},
			{
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "penguin_tuxedobird",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			},
			{
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "wildcat_leopard",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			},
			{
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "dog_classicdoggo",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			},
			{
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "bear_bear",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			},
			{
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "dog_classicdoggo",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			},
			{
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "turtle_tortoise",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			},
			{
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "chicken_chicken",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			},
			{
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "seal_seal",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			},
			{
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "bunny_bunny",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			},
			{
				"kind": "chromewebstore#payment",
				"itemId": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				"sku": "pig_pig",
				"createdTime": "1387221267248",
				"state": "ACTIVE"
			},
		]
	}
};

const getPurchasesErrorResponse = {
    "request": {},
    "response": {
        "errorType": "TOKEN_MISSING_ERROR",
    },
};

export const getSkuDetailsResponse = {
	"response": {
		"details": {
			"kind": "chromewebstore#inAppProductList",
			"inAppProducts": [
				{
					"kind": "chromewebstore#inAppProduct",
					"sku": "dog_lildoggo",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [
						{
							"valueMicros": "1000000",
							"currencyCode": "USD",
							"regionCode": "US"
						}
					],
					"localeData": [
						{
							"title": "Lil Doggo",
							"description": "",
							"languageCode": "en-US"
						}
					]
				},
				{
				"kind": "chromewebstore#inAppProduct",
					"sku": "penguin_tuxedobird",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [
						{
							"valueMicros": "1000000",
							"currencyCode": "USD",
							"regionCode": "US"
						}
					],
					"localeData": [
						{
							"title": "Tuxedo Birb",
							"description": "",
							"languageCode": "en-US"
						}
					]
				},
				{
					"kind": "chromewebstore#inAppProduct",
					"sku": "wildcat_leopard",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [
						{
							"valueMicros": "1000000",
							"currencyCode": "USD",
							"regionCode": "US"
						}
					],
					"localeData": [
						{
							"title": "Wild Kitty",
							"description": "",
							"languageCode": "en-US"
						}
					]
				},
				{
					"kind": "chromewebstore#inAppProduct",
					"sku": "bear_bear",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [
						{
							"valueMicros": "1000000",
							"currencyCode": "USD",
							"regionCode": "US"
						}
					],
					"localeData": [
						{
							"title": "Bear Cub",
							"description": "",
							"languageCode": "en-US"
						}
					]
				},
				{
					"kind": "chromewebstore#inAppProduct",
					"sku": "turtle_tortoise",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [
						{
							"valueMicros": "1000000",
							"currencyCode": "USD",
							"regionCode": "US"
						}
					],
					"localeData": [
						{
							"title": "Tortoise",
							"description": "",
							"languageCode": "en-US"
						}
					]
				},
				{
					"kind": "chromewebstore#inAppProduct",
					"sku": "dog_classicdoggo",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [
						{
							"valueMicros": "1000000",
							"currencyCode": "USD",
							"regionCode": "US"
						}
					],
					"localeData": [
						{
							"title": "Classic Doggo",
							"description": "",
							"languageCode": "en-US"
						}
					]
				},
				{
					"kind": "chromewebstore#inAppProduct",
					"sku": "chicken_chicken",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [
						{
							"valueMicros": "1000000",
							"currencyCode": "USD",
							"regionCode": "US"
						}
					],
					"localeData": [
						{
							"title": "Chicken Birb",
							"description": "",
							"languageCode": "en-US"
						}
					]
				},
				{
					"kind": "chromewebstore#inAppProduct",
					"sku": "seal_seal",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [
						{
							"valueMicros": "1000000",
							"currencyCode": "USD",
							"regionCode": "US"
						}
					],
					"localeData": [
						{
							"title": "Squishy Seal",
							"description": "",
							"languageCode": "en-US"
						}
					]
				},
				{
					"kind": "chromewebstore#inAppProduct",
					"sku": "bunny_bunny",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [
						{
							"valueMicros": "1000000",
							"currencyCode": "USD",
							"regionCode": "US"
						}
					],
					"localeData": [
						{
							"title": "Bunny Rabbit",
							"description": "",
							"languageCode": "en-US"
						}
					]
				},
				{
					"kind": "chromewebstore#inAppProduct",
					"sku": "pig_pig",
					"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
					"type": "inapp",
					"state": "ACTIVE",
					"prices": [
						{
							"valueMicros": "1000000",
							"currencyCode": "USD",
							"regionCode": "US"
						}
					],
					"localeData": [
						{
							"title": "Tubby Piggy",
							"description": "",
							"languageCode": "en-US"
						}
					]
				},

				// Coming Soon Product

				// {
				// 	"kind": "chromewebstore#inAppProduct",
				// 	"sku": "rock_rock",
				// 	"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
				// 	"type": "inapp",
				// 	"state": "ACTIVE",
				// 	"prices": [
				// 		{
				// 			"valueMicros": "1000000",
				// 			"currencyCode": "USD",
				// 			"regionCode": "US"
				// 		}
				// 	],
				// 	"localeData": [
				// 		{
				// 			"title": "Pet Rock",
				// 			"description": "",
				// 			"languageCode": "en-US"
				// 		}
				// 	]
				// },
			]
		}
	}
};

const getSkuDetailsErrorResponse = {
    "request": {},
    "response": {
        "errorType": "TOKEN_MISSING_ERROR",
    },
};

const onPurchase = {
	"jwt": "eyJhb...0oFuU",
	"request": {
		"cartId": "00000000000000000000.0000000000000000000"
	},
	"response": {
		"orderId": "00000000000000000000.0000000000000000000"
	},
	"checkoutOrderId": "10370910874874185126.d82d0d67c1e44407a5a54e855bf58ace",
};

const onPurchaseFail = {
	"response": {
		"error": 'The API call for buy failed',
		"errorType": 'api_fail',
	}
};


function getSkuDetails({ parameters, success, failure }) {
	// success handler
	setTimeout(() => success(getSkuDetailsResponse), 1000);
	// error handler
	setTimeout(() => failure(getSkuDetailsErrorResponse), 1000);
}

function getPurchases({ parameters, success, failure }) {
	// success handler
	setTimeout(() => success(getPurchasesResponse), 1000);
	// error handler
	setTimeout(() => failure(getPurchasesErrorResponse), 1000);
}

// DEVELOPMENT Only
function getPurchasesAfterBuy({ parameters, success, failure }) {
	// success handler
	setTimeout(() => success(getPurchasesAfterBuyResponse), 1000);
	// error handler
	setTimeout(() => failure(getPurchasesErrorResponse), 1000);
}
// DEVELOPMENT Only

function buy({ parameters, sku, success, failure }) {
	// success handler
	setTimeout(() => success(onPurchase), 1000);
	// error handler
	setTimeout(() => failure(onPurchaseFail), 1000);
}

// const google = {
// 	payments: {
// 		inapp: {
// 			getSkuDetails,
// 			getPurchases,
// 			getPurchasesAfterBuy,
// 			buy,
// 		},
// 	},
// };

// window.google = google;



// WEBPACK FOOTER //
// ./src/utils/fakeGoogle.js